import createApp from 'beebee-base/core-app';
import ENV from 'beebeeboard-booking/config/environment';
import Resolver from 'ember-resolver';
import compatModules from '@embroider/virtual/compat-modules';
// Embroider: app styles compile through webpack (sass-loader) into the managed
// app-CSS bundle. Imported via webpack alias — see ember-cli-build.js.
import './styles/app.scss';
import 'paymentfont/css/paymentfont.min.css';
import { registerDateLibrary } from 'ember-power-calendar';
import DateUtils from 'ember-power-calendar-moment';

registerDateLibrary(DateUtils);

const CoreApp = createApp(ENV, { compatModules });

export default class App extends CoreApp {
  Resolver = Resolver.withModules(compatModules);
}
